<template>
  <div>
    <transition name="fade" mode="out-in">
      <div v-if="!isApproved">
        <b-row v-if="!isCommunitySubscription" class="d-flex justify-content-center">
          <b-col cols="8" class="d-flex justify-content-center align-items-center flex-column my-3">
            <b-alert :show="isCancelled" variant="warning" dismissible>
              <div class="alert-body">
                {{ $t('edit-community-modal.subscription.getting-started.cancelled') }}
              </div>
            </b-alert>
            <div>
              <h3 class="text-center">
                {{ $t('service-subscription.getting-started.not-subscribed-yet') }}
              </h3>
              <premium-banner-features />
            </div>
            <b-button variant="primary" class="mt-2" size="lg" @click="openSubscriptionModal">
              {{ $t('actions.subscribe-now') }}
            </b-button>
          </b-col>
        </b-row>
        <b-row v-else class="d-flex justify-content-center">
          <b-col cols="8">
            <div class="d-flex justify-content-center align-items-center flex-column my-3">
              <h4 class="text-center">
                {{ $t('edit-community-modal.subscription.getting-started.community-subscribed.title') }}
              </h4>
              <p class="text-center">
                {{ $t('edit-community-modal.subscription.getting-started.community-subscribed.description') }}
              </p>
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-else>
        <b-row class="d-flex justify-content-center">
          <b-col cols="8" class="text-center">
            <div class="d-flex justify-content-center">
              <b-spinner variant="primary" class="my-5" size="lg" />
            </div>
            <p>{{ $t('edit-community-modal.subscription.getting-started.waiting-for-paiement-confirmation') }}</p>
          </b-col>
        </b-row>
      </div>
    </transition>
  </div>
</template>

<script>
import { BRow, BCol, BButton, BAlert, BSpinner } from 'bootstrap-vue'
import PremiumBannerFeatures from '@core/components/premium-banner/PremiumBannerFeatures.vue'
import { getUserData } from '@/auth/utils'

export default {
  name: 'GettingStarted',
  components: {
    // BSV
    BRow,
    BCol,
    BButton,
    BAlert,
    BSpinner,

    // Custom
    PremiumBannerFeatures,
  },
  props: {
    isCommunitySubscription: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCancelled: false,
      isApproved: false,
    }
  },
  methods: {
    openSubscriptionModal() {
      const user = getUserData()
      this.isCancelled = false

      window.Paddle.Checkout.open({
        product: process.env.VUE_APP_PADDLE_PLAN_ID,
        allowQuantity: false,
        quantity: 1,
        passthrough: JSON.stringify({
          createdBy: user.id,
          services: [this.$store.state.selection.service.id],
        }),
        locale: this.$i18n.locale,
        successCallback: this.onSubscribed,
        closeCallback: this.onCancel,
      })
    },
    onSubscribed() {
      this.isApproved = true

      this.$emit('on-approve')
    },
    onCancel() {
      this.isCancelled = true
    },
    onError(error) {
      this.$emit('error', error)
    },
  },
}
</script>

<style></style>
